import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import { FaSave } from "react-icons/fa";
import { useSelector } from "react-redux";

const RegisterDeliverCard = ({ register, taskId, userStatus, successChildUpdate, updateStatusFromChild, updateTask }) => {

    const user = useSelector((state) => state.auth.user); // Usuario => IMPORTANTE!
    
    const [deliverStatus, setDeliverStatus] = useState(register.deliverStatus);
    const [reviewedBy , setReviewedBy] = useState(register.reviewedBy || null)
    const [bossNotes, setBossNotes] = useState(register.bossNotes)

    const updateDeliverStatus = async () => {
        try {
            // Obtener la tarea actual
            const { data: taskData } = await axios.get(`${BACKEND}/api/tareasProyectos/${taskId}`);

            const updatedDeliverHistorical = taskData.deliverHistorical.map(item => {
                if (item.id === register.id) {
                    return {
                        ...item,
                        deliverStatus: deliverStatus,
                        reviewedBy: user.name,
                        bossNotes: bossNotes
                    };
                }
                return item;
            });
    
            await axios.put(`${BACKEND}/api/tareasProyectos/${taskId}`, {
                deliverHistorical: updatedDeliverHistorical
            });
    
            successChildUpdate();
            updateTask()
            updateStatusFromChild(deliverStatus === "Declinado" ? "Declinado" : deliverStatus === "Por revisar" ? "Finalizado" : deliverStatus === "Aprobado" ? "Finalizado" : "" );

            setDeliverStatus(deliverStatus)
            setReviewedBy(user.name)


            toast.success("Estado de entrega actualizado correctamente");
        } catch (error) {
            console.error(error);
            toast.error("Error al actualizar el estado de entrega");
        }
    };

    const handleDeliverStatusChange = (e) => {
        setDeliverStatus(e.target.value);
    };

    return (
        <div className="rounded-md shadow-md border border-gray-300 p-3 gap-4">
            <div>
                <p className="text-xs text-gray-600">
                    Fecha entrega: {new Date(register.deliverDate).toLocaleDateString('es-ES', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                    })} 
                    {" "} a las {new Date(register.deliverDate).toLocaleTimeString('es-ES', {
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit',
                    })}
                </p>
            </div>
            <hr />
            <div className="py-2">
                <span className="text-xs text-gray-600 font-semibold">Links:</span>
                <ul className="list-disc ml-8">
                    {register?.evidenceLinks.length > 0 ? (
                        register?.evidenceLinks.map((link, id) => (
                            <li key={id}>
                                <a href={link.link} target="_blank" rel="noopener noreferrer" className="text-blue-500 text-xs hover:underline">
                                    {link.link}
                                </a>
                            </li>
                        ))
                    ) : (
                        <span className="text-gray-600 text-xs">No hay links disponibles</span>
                    )}
                </ul>
            </div>
            <hr />
            <div className="flex flex-col w-full gap-2 py-2">
                <span className="text-xs text-gray-600 font-semibold">Comentarios responsable:</span>
                <span className="text-xs text-gray-600 px-3">{register.workerNotes}</span>
            </div>
            <hr />
            <div className="flex flex-col w-full gap-2 py-2">
                <span className="text-xs text-gray-600 font-semibold">Comentarios jefe de área:</span>
                <input 
                    type="text"
                    id="bossNotes"
                    value={bossNotes}
                    onChange={(e) => setBossNotes(e.target.value)}
                    className="border border-gray-200 text-xs rounded-md shadow-sm"
                    disabled={userStatus !== "SuperAdmin"}
                />
            </div>
            <hr />
            <div className="flex flex-row gap-4 items-center justify-between py-2 mt-3">
                <div className="flex flex-row justify-center items-center gap-2 w-1/2">
                    <span className="text-xs text-gray-600 font-semibold">Estado:</span>
                    <select 
                        name="statusDeliverRegister" 
                        id="statusDeliverRegister"
                        value={deliverStatus} // Actualiza el estado de deliverStatus
                        onChange={handleDeliverStatusChange} // Cambia el valor al seleccionar una opción
                        disabled={userStatus !== "SuperAdmin"}
                        className={`p-0 rounded-md text-xs border-none mb-1
                            ${deliverStatus === "Declinado" ? "text-orange-500" : ""}
                            ${deliverStatus === "Por revisar" ? "text-yellow-500" : ""}
                            ${deliverStatus === "Aprobado" ? "text-green-500" : ""}
                        `}
                    >
                        <option key={"1"} value={"Declinado"} className="text-orange-500 p-0">Declinado</option>
                        <option key={"2"} value={"Por revisar"} className="text-yellow-500 p-0">Por revisar</option>
                        <option key={"3"} value={"Aprobado"} className="text-green-500 p-0">Aprobado</option>
                    </select>
                </div>
                <div className="flex flex-row justify-center items-center gap-2 w-1/2">
                    <span className="text-xs text-gray-600 font-semibold">
                        Revisado por: {reviewedBy || "N/A"}
                    </span>
                </div>
            </div>
            {userStatus === "SuperAdmin" ? (
                <>
                    <hr />
                    <div className="flex justify-center items-center py-2 mt-3">
                        <button 
                            onClick={updateDeliverStatus} // Se envía la actualización al hacer clic en el botón
                            className="px-5 py-1 text-xs font-bold bg-orange-500 text-white rounded-md flex items-center justify-center gap-2 hover:bg-orange-600 transition-all duration-100"
                            disabled={userStatus !== "SuperAdmin"}
                        >
                            <FaSave /> Guardar cambios
                        </button>
                    </div>
                </>
            ) : (
                false
            )}

        </div>
    )
}

export default RegisterDeliverCard;
